// components/EventHeader/OrganizerInfo.js

import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import Typography from '../Typography';
import { theme } from '../../theme';
import { useTranslation } from 'react-i18next';
import HelmetIcon from '../Icons/HelmetIcon';

const OrganizerInfo = ({ organizer }) => {
  const { t } = useTranslation('eventDetail');
  return (
    <OrganizerContainer>
      <OrganizerLink to={`/user/${organizer.id}`}>
        {organizer.userAvatar ? (
          <OrganizerAvatar src={organizer.userAvatar} alt={t('eventDetailHeader.organizer')} />
        ) : (
          <AvatarPlaceholder>
            <HelmetIcon width={32} height={32} fill={theme.colors.defaultStrong} />
          </AvatarPlaceholder>
        )}
        <OrganizerData>
          <Typography $variant='caption-medium' color={theme.colors.defaultWeak}>
            {t('eventDetailHeader.organizedBy')}
          </Typography>
          <Typography $variant='body-2-semibold' color={theme.colors.defaultMain}>
            {organizer.name} {organizer.lastName}
          </Typography>
        </OrganizerData>
      </OrganizerLink>
    </OrganizerContainer>
  );
};

export default OrganizerInfo;

// Styled Components
const OrganizerContainer = styled.div`
  display: flex;
  flex-shrink: 0;
  margin-left: -${({ theme }) => theme.sizing.xs};
`;

const OrganizerLink = styled(Link)`
  align-items: center;
  border-radius: ${({ theme }) => theme.radius.xs};
  display: flex;
  gap: ${({ theme }) => theme.sizing.xs};
  padding: ${({ theme }) => theme.sizing.xs};
  padding-right: ${({ theme }) => theme.sizing.sm};
  text-decoration: none;
  transition: all 0.3s ease-in-out;

  &:hover {
    background-color: ${({ theme }) => theme.fill.defaultWeak};
  }
`;

const OrganizerData = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`;

const OrganizerAvatar = styled.img`
  border-radius: ${({ theme }) => theme.radius.xs};
  height: 40px;
  width: 40px;
`;

const AvatarPlaceholder = styled.div`
  align-items: center;
  background-color: ${({ theme }) => theme.fill.defaultWeak};
  border-radius: ${({ theme }) => theme.radius.xs};
  display: flex;
  height: 40px;
  justify-content: center;
  width: 40px;
`;
